"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = __importStar(require("react"));
var GameCollections_1 = require("../../GameCollections");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var GamesByFilters = function (_a) {
    var _b, _c;
    var selectedCollection = _a.selectedCollection, gameCardPlaceholder = _a.gameCardPlaceholder, columnsCount = _a.columnsCount, correctionCoefficient = _a.correctionCoefficient, imageLoading = _a.imageLoading, titlePosition = _a.titlePosition, navigationPosition = _a.navigationPosition;
    var geoData = (0, swr_hooks_1.useGeo)().data;
    var games = (0, swr_hooks_1.useGamesByCategories)().data;
    var collectionIncludeGEO = (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d;
        return (games === null || games === void 0 ? void 0 : games["".concat(selectedCollection, "_").concat((_b = (_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode) === null || _b === void 0 ? void 0 : _b.toLowerCase())])
            ? "".concat(selectedCollection, "_").concat((_d = (_c = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _c === void 0 ? void 0 : _c.countryCode) === null || _d === void 0 ? void 0 : _d.toLowerCase())
            : selectedCollection;
    }, [selectedCollection, (_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode, games]);
    if (!collectionIncludeGEO)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(GameCollections_1.GameCollections, { games: ((_c = games === null || games === void 0 ? void 0 : games[collectionIncludeGEO]) === null || _c === void 0 ? void 0 : _c.previewGames) || [], category: collectionIncludeGEO, collectionIndex: 0, rowCount: 2, columnsCount: columnsCount, gameCardPlaceholder: gameCardPlaceholder, correctionCoefficient: correctionCoefficient, imageLoading: imageLoading, titlePosition: titlePosition, navigationPosition: navigationPosition })));
};
exports.default = GamesByFilters;
